/*
 *
 * SignInPage
 *
 */

import React from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { signInRequest } from './actions';
import { getSearchParam } from 'utils/helpers';
import { Wrapper, Heading } from './styledComponents';
import { setModal } from 'containers/RootModal/actions';
import {
  INVALID_EMAIL,
  INVALID_PASSWORD,
  PASSWORD_REQUIREMENTS,
} from 'containers/RootModal/constants';
import Form from './Form';
import H1 from 'components/H1';

const SignInPage = ({
  onSignInSubmit,
  location: { search },
  openInvalidEmailModal,
  openInvalidPasswordModal,
  openPasswordRequirementsModal,
  }) => {
  const email = getSearchParam(search, 'email');
  return (
    <Wrapper>
      <Helmet title='Movebooth | Sign In' />
      <Heading>
        <H1>
        👋 Welcome back.
        </H1>
        <p>
          Please enter your Movebooth login details to sign in and start making some serious moves.
        </p>
      </Heading>
      <Form
        onSubmit={onSignInSubmit}
        initialValues={{ email }}
        openInvalidEmailModal={openInvalidEmailModal}
        openInvalidPasswordModal={openInvalidPasswordModal}
        openPasswordRequirementsModal={openPasswordRequirementsModal}
      />
    </Wrapper>
  );
}

const mapDispatchToProps = (dispatch) => ({
  onSignInSubmit: (data) => dispatch(signInRequest(data)),

  openInvalidEmailModal: () =>
    dispatch(setModal({ modalType: INVALID_EMAIL })),

  openInvalidPasswordModal: (modalProps) =>
    dispatch(setModal({ modalType: INVALID_PASSWORD, modalProps })),

  openPasswordRequirementsModal: () =>
    dispatch(setModal({ modalType: PASSWORD_REQUIREMENTS })),
});

export default connect(null, mapDispatchToProps)(SignInPage);



// WEBPACK FOOTER //
// ./src/containers/SignInPage/index.js